
  import Vue from "vue";
  import * as replyAPI from "@/api/replies";
  import Header from "../models/header";
  import Options from "@/models/options";
  import {ReplyLog} from "@/api/replies";


  export default Vue.extend( {
    name: "ReplyLogs",
    data() {
      return {
        loading: false as boolean,
        items: [] as ReplyLog[],
        total: 0 as number,
        options: {} as Options,
        expanded: []
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        this.loading = true;
        let limit = this.options.itemsPerPage;
        let skip =
            (this.options.page ? this.options.page - 1 : 0) *
            (this.options.itemsPerPage ?? 0);
        if (!limit || limit < 0) {
          limit = this.total;
        }
        replyAPI.listLogs(limit, skip).then(resp => {
          this.total = resp.total;
          this.items = resp.data;
          // console.log(resp);
          this.loading = false;
        }).catch(_ => {
          this.loading = false;
        })
      },
      getExpandedTitle(item: any) {
        switch (item.action) {
          case "create":
            return this.$t("replyLogs.actions.title.create");
          case "edit":
            return this.$t("replyLogs.actions.title.edit");
          default:
            return this.$t("replyLogs.actions.title.create");
        }
      },
      getActionText(item: any) {
        switch (item.action) {
          case "create":
            return this.$t("replyLogs.actions.create");
          case "edit":
            return this.$t("replyLogs.actions.edit");
          default:
            return this.$t("replyLogs.actions.create");
        }
      },
    },
    watch: {
      options: {
        handler(): void {
          this.getData();
        },
        deep: true,
      },
    },
    computed: {
      headers: {
        set() {
          return [];
        },
        get() {
          return [
            new Header(this.$t("replyLogs.headers.formName"), "formName", false),
            // new Header(this.$t("replyLogs.headers.id"), "id", false),
            new Header(this.$t("replyLogs.headers.userName"), "userName", false),
            new Header(this.$t("replyLogs.headers.tenantName"), "tenantName", false),
            new Header(this.$t("replyLogs.headers.createdAt"), "createdAt", false),
            new Header(this.$t("replyLogs.headers.action"), "action", false),
            new Header("", "data-table-expand", false)
          ];
        },
      },
    },
  })
